<template>
  <v-col v-if="files" class="pa-0">
    <v-row v-for="file in files" :key="file.key" class="mb-2" dense>
      <transaction-file
        test-id="transaction-file-list"
        :file="file"
        @downloadCertificate="handleClickDocument"
      ></transaction-file>
    </v-row>
  </v-col>
  <v-col v-else>
    <span>{{ $vuetify.lang.t("$vuetify.withoutFiles") }}</span>
  </v-col>
</template>

<script>
import transactionFile from "@/components/sections/transactions/components/TransactionFile.vue";

export default {
  name: "TransactionFilesList",
  components: { transactionFile },
  props: {
    files: [Array, null],
    certificateVisible: Boolean,
  },
  data() {
    return {
      downloadLoading: false,
    };
  },
  methods: {
    async handleClickDocument(document) {
      if (document.key === "certificate") {
        this.$emit("certificate");
      }
    },
  },
};
</script>
